/* eslint-disable react-hooks/exhaustive-deps */
import CustomButton from "components/CustomButton/CustomButton";
import DisketIcon from "icons/DisketIcon";
import UserIcon2 from "icons/UserIcon2";
import { useEffect, useState } from "react";
import { Container } from "./styles";

const BUTTON_STYLES = {
    variant: "secondary",
    width: "100%"
};

const ActionButtons = ({
    studentList, 
    selectedStudents,
    isForUpdatePenalty,
    finalized,
    notActions,
    actions: {
        openTakeStudentAttendanceDialog,
        openPenalizeStudentDialog,
        openDeleteStudentDialog,
        openAddStudentDialog,
        openSaveInformationDialog
    }
}) => {
    const [thereAreStudentsNoCompletlyAdded, setThereAreStudentsNoCompletlyAdded] = useState(false);
    const [hasBeenSelectedResponsibleStudent, setHasBeenSelectedResponsibleStudent] = useState(false);
    const [maxCapacityHasBeenReached, setMaxCapacityHasBeenReached] = useState(false);
    const [allSelectedStudentsHaveAttendance, setAllSelectedStudentsHaveAttendance] = useState(false);
    //#region Effects
    useEffect(() => {
        setThereAreStudentsNoCompletlyAdded(selectedStudents.existSelectedStudentsNotSaved());
        setHasBeenSelectedResponsibleStudent(selectedStudents.checkIfHasBeenSelectedResponsibleStudent());
        setAllSelectedStudentsHaveAttendance(selectedStudents.allStudentsHaveAttendance());
    }, [selectedStudents.value]);
    useEffect(() => {
        setMaxCapacityHasBeenReached(studentList.maxCapacityHasBeenReached());
    }, [studentList.value]);
    //#endregion
    //#region Functions
    //#endregion
    const noSelected = selectedStudents.noSelected();
    const disabledButtons = {
        takeAttendance: (
            finalized ||
            noSelected || 
            thereAreStudentsNoCompletlyAdded
        ),
        penalty: (
            noSelected || 
            thereAreStudentsNoCompletlyAdded || 
            !allSelectedStudentsHaveAttendance 
        ),
        delete: (
            finalized || 
            hasBeenSelectedResponsibleStudent || 
            noSelected
        ),
        add: (
            finalized ||
            maxCapacityHasBeenReached
        )
    };
    return (
        <Container>
            <CustomButton
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="check"/>} 
                text="Marcar asistencia"
                onClick={openTakeStudentAttendanceDialog}
                disabled={disabledButtons.takeAttendance}/>
            <CustomButton 
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="cross"/>} 
                text={isForUpdatePenalty() ? "Editar sanción(es)" : "Sancionar alumno(s)"}
                onClick={openPenalizeStudentDialog}
                disabled={disabledButtons.penalty}/>
            <CustomButton 
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="hypen"/>} 
                text="Eliminar alumno(s)"
                onClick={openDeleteStudentDialog}
                disabled={disabledButtons.delete}/>
            <CustomButton 
                {...BUTTON_STYLES}
                icon={<UserIcon2 variant="plus"/>} 
                text="Agregar alumno(s)"
                onClick={openAddStudentDialog}
                disabled={disabledButtons.add}/>
            <CustomButton 
                {...BUTTON_STYLES}
                variant="primary"
                icon={<DisketIcon/>} 
                text="Guardar información"
                onClick={openSaveInformationDialog}
                disabled={notActions}/>
        </Container>
    );
}

export default ActionButtons;